module.exports = __webpack_public_path__ + "assets/img/100607.b2ee1b27.png";